/** @jsxImportSource @emotion/react */
import React from 'react';
import { style as s } from '../style';
import { ReactComponent as LayerIcon } from 'assets/icons/icon_layers.svg';
import { ReactComponent as ChartIcon } from 'assets/icons/icon_chart.svg';
import { ReactComponent as SettingIcon } from 'assets/icons/icon_settings.svg';
import CalculateRoundedIcon from '@mui/icons-material/CalculateRounded';

// 탭 버튼 목록
const TABS = [
    { id: 'layer', index: 0, label: '레이어', icon: LayerIcon },
    { id: 'chart', index: 1, label: '차트', icon: ChartIcon },
    { id: 'setting', index: 2, label: '설정', icon: SettingIcon },
];

const TabMenu = ({
    activeTab,
    setActiveTab,
    tabs = TABS,
    collapsed = false,
    showCalculatorButton = false,
    onCalculatorOpen = null,
}) => (
    <div css={[s.iconTabArea, collapsed && s.iconTabAreaCollapsed]}>
        <div css={s.tabList}>
            {tabs.map((tab) => {
                const Icon = tab.icon || LayerIcon;

                return (
                    <div
                        key={tab.id}
                        css={[
                            s.iconTabButton,
                            collapsed && s.iconTabButtonCollapsed,
                            activeTab === tab.id && s.iconTabButtonActive,
                        ]}
                        onClick={() => setActiveTab?.(tab.id)}
                    >
                        <span className="tab-icon">
                            <Icon style={{ width: '18px', height: '18px' }} />
                        </span>
                        {!collapsed && <span className="tab-label">{tab.label}</span>}
                    </div>
                );
            })}

            {showCalculatorButton && (
                <>
                    <div css={s.tabDivider} />
                    <button
                        type="button"
                        css={[s.utilityButton, collapsed && s.utilityButtonCollapsed]}
                        onClick={onCalculatorOpen}
                    >
                        <span className="tab-icon">
                            <CalculateRoundedIcon fontSize="small" />
                        </span>
                        {!collapsed && <span className="tab-label">계산기</span>}
                    </button>
                </>
            )}
        </div>
    </div>
);

export default TabMenu;
